export const PATH_OFF_PLATFORM_SERVICES = '/additionalServices'
export const PATH_OFF_PLATFORM_SERVICES_WELCOME = `${PATH_OFF_PLATFORM_SERVICES}/welcome`
export const PATH_OFF_PLATFORM_SERVICES_DETAILS = `${PATH_OFF_PLATFORM_SERVICES}/:id`
export const PATH_OFF_PLATFORM_SERVICES_SUMMARY = `${PATH_OFF_PLATFORM_SERVICES}/:id/summary`

export const PATH_ADDITIONAL_CHARGES = '/additionalCharges'
export const PATH_AGENT_AUTHORISATION = '/authorisation'
export const PATH_BUNDLE = '/bundle'
export const PATH_BUNDLE_REASONS = '/bundle/reasons'
export const PATH_BUNDLE_PAYMENT = '/bundle/payment'
export const PATH_DASHBOARD = '/overview'
export const PATH_FILES = '/files'
export const PATH_FILES_SELF_ASSESSMENT = `${PATH_FILES}/:selfAssessmentId(\\d+)`
export const PATH_FILES_OTHER = '/files/other'
export const PATH_FILES_TAX_REGISTRATION = '/files/taxRegistration'
export const PATH_FILES_TAX_CONSULTATIONS = '/files/taxConsultations'
export const PATH_FILES_TAX_RELIEF_CLAIMS = '/files/taxReliefClaims'
export const PATH_FILES_COMPANY = '/files/company/:companyId'
export const PATH_FILES_SUBSCRIPTIONS = '/files/subscriptions'
export const PATH_FINANCES = '/finances'
export const PATH_FINANCES_INVOICING = '/finances/invoicing'
export const PATH_FINANCES_TRACKING = '/finances/tracking'
export const PATH_FINANCES_TRACKING_INCOMES = '/finances/tracking/incomes'
export const PATH_FINANCES_TRACKING_EXPENSES = '/finances/tracking/expenses'
export const PATH_FINANCES_TRACKING_BANKING_PROVIDERS = `${PATH_FINANCES_TRACKING}/banking/providers`
export const PATH_FINANCES_TRACKING_BANKING_TRANSACTIONS = `${PATH_FINANCES_TRACKING}/banking/transactions/overview`
export const PATH_HMRC_CALLBACK = '/hmrc/authenticated/'
export const PATH_IDENTITY_VERIFICATION = '/verification'
export const PATH_LOGOUT = '/logout'
export const PATH_MAGIC_LINK = '/link/:identifier'
export const PATH_MEETINGS = '/messages/meetings'
export const PATH_MEETING = '/messages/meetings/:accountantMeetingId(\\d+)'
export const PATH_MESSAGES = '/messages'
export const PATH_MOBILE_NOTIFICATIONS = '/mobile/notifications'
export const PATH_ONBOARDING = '/onboarding'
export const PATH_ONBOARDING_TAXES = `${PATH_ONBOARDING}/taxes`
export const PATH_ONBOARDING_TAX_RETURN = `${PATH_ONBOARDING}/taxReturn`
export const PATH_ONBOARDING_TAX_RETURN_LATEST = `${PATH_ONBOARDING}/taxReturn/latest`
export const PATH_ONBOARDING_PLATFORM = `${PATH_ONBOARDING}/platform`
export const PATH_ONBOARDING_SUBSCRIPTION = `${PATH_ONBOARDING}/subscription`
export const PATH_ONBOARDING_PLATFORM_TRACKING = `${PATH_ONBOARDING_PLATFORM}/tracking`
export const PATH_ONBOARDING_PLATFORM_INVOICING = `${PATH_ONBOARDING_PLATFORM}/invoicing`
export const PATH_ONBOARDING_PLATFORM_BANKING = `${PATH_ONBOARDING_PLATFORM}/banking`
export const PATH_ONBOARDING_PLATFORM_BANKING_PROVIDERS = `${PATH_ONBOARDING_PLATFORM_BANKING}/providers`
export const PATH_ONBOARDING_PLATFORM_INVOICING_DETAILS = `${PATH_ONBOARDING_PLATFORM_INVOICING}/details`
export const PATH_ONBOARDING_PLATFORM_INVOICING_APPEARANCE = `${PATH_ONBOARDING_PLATFORM_INVOICING}/appearance`
export const PATH_PAYMENT_CONFIRMATION = '/paymentconfirmation'
export const PATH_PROFILE = '/profile'
export const PATH_PROFILE_BANK_DETAILS = '/profile/bankDetails'
export const PATH_PROFILE_EMAIL = '/profile/email'
export const PATH_PROFILE_INTEGRATIONS = '/profile/integrations'
export const PATH_PROFILE_INTEGRATIONS_KOINLY = `${PATH_PROFILE_INTEGRATIONS}/koinly`
export const PATH_PROFILE_PARTNER_DETAILS = '/profile/partnerDetails'
export const PATH_PROFILE_SECURITY = '/profile/security'
export const PATH_PROFILE_SECURITY_MFA = '/profile/security/mfa'
export const PATH_PROFILE_SECURITY_MFA_DELETE = '/profile/security/mfa/delete/:selectedPhoneFactorIndex'
export const PATH_PROFILE_SECURITY_MFA_ENROLL = '/profile/security/mfa/enroll'
export const PATH_PROFILE_SECURITY_MFA_STATUS = '/profile/security/mfa/status'
export const PATH_PROFILE_SELF_EMPLOYMENT = '/profile/selfEmployment'
export const PATH_PROFILE_SUBSCRIPTION = '/profile/subscription'
export const PATH_PROFILE_VERIFICATION = '/profile/verification'
export const PATH_REFERRALS = '/invite'
export const PATH_ROOT = '/'
export const PATH_SUBSCRIPTION_CONFIRMATION = '/subscriptionconfirmation/:tier'
export const PATH_TAXES = '/taxes'
export const PATH_TAXES_HASH_SELF_ASSESSMENTS = '#selfAssessments'
export const PATH_TAX_CONSULTATION = '/taxConsultation'
export const PATH_TAX_CONSULTATION_CREATE = `${PATH_TAX_CONSULTATION}/create`
export const PATH_TAX_CONSULTATION_ID = `${PATH_TAX_CONSULTATION}/:taxConsultationId(\\d+)`
export const PATH_TAX_CONSULTATION_STEP_CONTACT = `${PATH_TAX_CONSULTATION_ID}/contact`
export const PATH_TAX_CONSULTATION_STEP_PHONE = `${PATH_TAX_CONSULTATION_ID}/phone`
export const PATH_TAX_CONSULTATION_STEP_TOPICS = `${PATH_TAX_CONSULTATION_ID}/topics`
export const PATH_TAX_CONSULTATION_STEP_NOTES = `${PATH_TAX_CONSULTATION_ID}/notes`
export const PATH_TAX_CONSULTATION_STEP_UPLOADS = `${PATH_TAX_CONSULTATION_ID}/uploads`
export const PATH_TAX_CONSULTATION_STEP_PAYMENT = `${PATH_TAX_CONSULTATION_ID}/payment`
export const PATH_TAX_CONSULTATION_STEP_SCHEDULE = `${PATH_TAX_CONSULTATION_ID}/schedule`
export const PATH_TAX_CONSULTATION_STEP_SUMMARY = `${PATH_TAX_CONSULTATION_ID}/summary`
export const PATH_TAX_CONSULTATIONS = '/taxConsultations'
export const PATH_TAX_REGISTRATION = '/taxRegistration'
export const PATH_TAX_REGISTRATION_START = '/taxRegistration/start'
export const PATH_TAX_REGISTRATION_TYPE = '/taxRegistration/type'
export const PATH_TAX_REGISTRATION_REASONS = '/taxRegistration/reasons'
export const PATH_TAX_REGISTRATION_DETAILS = '/taxRegistration/details'
export const PATH_TAX_REGISTRATION_PAYMENT = '/taxRegistration/payment'
export const PATH_TAX_REGISTRATION_SUMMARY = '/taxRegistration/summary'
export const PATH_TAX_RELIEF_CLAIMS = '/eis'
export const PATH_TAX_RELIEF_CLAIMS_START = '/eis/start'
export const PATH_TAX_RELIEF_CLAIMS_PAYMENT = '/eis/payment'
export const PATH_TAX_RELIEF_CLAIMS_CREATE = '/eis/:taxReliefClaimId'
export const PATH_TAX_RELIEF_CLAIMS_UPLOAD = '/eis/:taxReliefClaimId/upload'
export const PATH_TAX_RELIEF_CLAIMS_DETAILS = '/eis/:taxReliefClaimId/details'
export const PATH_TAX_RELIEF_CLAIMS_CONFIRM = '/eis/:taxReliefClaimId/confirm'

export const PATH_WELCOME = '/welcome'
export const PATH_WELCOME_QUESTIONS = `${PATH_WELCOME}/questions`
export const PATH_WELCOME_QUESTIONS_CUSTOMER_TYPE = `${PATH_WELCOME_QUESTIONS}#customerTypeSelection` // First question
export const PATH_WELCOME_QUESTIONS_SELF_EMPLOYMENT_STATUS = `${PATH_WELCOME_QUESTIONS}#selfEmploymentStatus`
export const PATH_WELCOME_INDIVIDUAL = `${PATH_WELCOME}/individual`
export const PATH_WELCOME_COMPANY = `${PATH_WELCOME}/company`
export const PATH_WELCOME_ONBOARDING = '/onboardingWelcome'

export const PATH_WELCOME_SELF_ASSESSMENT = `${PATH_WELCOME}/selfAssessment`
export const PATH_WELCOME_SELF_ASSESSMENT_QUESTIONS = `${PATH_WELCOME_SELF_ASSESSMENT}/questions`
export const PATH_WELCOME_SELF_ASSESSMENT_QUESTIONS_TAX_YEAR = `${PATH_WELCOME_SELF_ASSESSMENT_QUESTIONS}#taxYear` // First question
export const PATH_WELCOME_SELF_ASSESSMENT_QUESTIONS_INCOME_SOURCES = `${PATH_WELCOME_SELF_ASSESSMENT_QUESTIONS}#incomeSources`
export const PATH_WELCOME_SELF_ASSESSMENT_SUMMARY = `${PATH_WELCOME_SELF_ASSESSMENT}/summary`

export const PATH_WELCOME_TAX_CONSULTATION = `${PATH_WELCOME}/taxConsultation`
export const PATH_WELCOME_TAX_CONSULTATION_QUESTIONS = `${PATH_WELCOME_TAX_CONSULTATION}/questions`
export const PATH_WELCOME_TAX_CONSULTATION_QUESTIONS_TOPICS = `${PATH_WELCOME_TAX_CONSULTATION_QUESTIONS}#taxConsultationTopics` // First question
export const PATH_WELCOME_TAX_CONSULTATION_SUMMARY = `${PATH_WELCOME_TAX_CONSULTATION}/summary`

export const PATH_WELCOME_BUNDLE = `${PATH_WELCOME}/bundle`
export const PATH_WELCOME_BUNDLE_QUESTIONS = `${PATH_WELCOME_BUNDLE}/questions`
export const PATH_WELCOME_BUNDLE_QUESTIONS_REASONS = `${PATH_WELCOME_BUNDLE_QUESTIONS}#bundleReasons` // First question
export const PATH_WELCOME_BUNDLE_SUMMARY = `${PATH_WELCOME_BUNDLE}/summary`

export const PATH_LOGIN = '/login'
export const PATH_RESET_PASSWORD = '/resetPassword'
export const PATH_SIGNUP = '/signup'
export const PATH_SIGNUP_GOOGLE = '/signup/google'

// Self Assessment paths
export const PATH_SELF_ASSESSMENT_DOCUMENTS = '/documents'
export const PATH_SELF_ASSESSMENT_QUESTIONS = '/questions'
export const PATH_SELF_ASSESSMENT_REASONS = '/reasons'
export const PATH_SELF_ASSESSMENT_PAYWALL = '/paywall'
export const PATH_SELF_ASSESSMENT_GBB = '/gbb'
export const PATH_SELF_ASSESSMENT_GBB_CONFIRMATION = '/gbb/confirmation/:paymentType'
export const PATH_SELF_ASSESSMENT_REVIEW = '/review'
export const PATH_SELF_ASSESSMENT_SOURCES = '/sources'
export const PATH_SELF_ASSESSMENT_SUMMARY = '/summary'
export const PATH_SELF_ASSESSMENT_ANNUAL_CONFIRMATION = '/annual/confirmation'
export const PATH_SELF_ASSESSMENT_SUMMARY_HASH_SUBMIT = '#submit'
export const PATH_SELF_ASSESSMENT_SUMMARY_HASH_ACCOUNTANT = '#assignAccountant'

// Tax Return paths (self assessment onboarding revamp)
export const PATH_TAX_RETURN = {
    BASE: '/taxreturn',
    AUTH: '/taxreturn/auth',
    TAX_RETURN_ID: '/taxreturn/:taxReturnId(\\d+)',
    QUESTIONS: `/taxreturn/:taxReturnId(\\d+)/questions`,
    PAYMENT: `/taxreturn/:taxReturnId(\\d+)/payment`,
    PAID: `/taxreturn/:taxReturnId(\\d+)/paid`,
} as const

// Company service eligibility paths
export const PATH_COMPANY_SERVICE_ELIGIBILITY_START = '/companyservices'
export const PATH_COMPANY_SERVICE_ELIGIBILITY_SUMMARY = `${PATH_COMPANY_SERVICE_ELIGIBILITY_START}/summary`

// Company subscription paths
export const PATH_COMPANY_SUBSCRIPTION_START = '/companysubscription'
export const PATH_COMPANY_SUBSCRIPTION_PAYMENT = `${PATH_COMPANY_SUBSCRIPTION_START}/:companyId/payment`

// Company return unregistered user paths
export const PATH_COMPANY_RETURN_START = '/companyReturn'
export const PATH_COMPANY_RETURN_QUESTIONS_UNREGISTERED_USER = '/companyReturn/questions'
export const PATH_COMPANY_RETURN_RESET = `${PATH_COMPANY_RETURN_QUESTIONS_UNREGISTERED_USER}/reset`

// Company return registered user paths
export const PATH_COMPANY_RETURN = '/company/:companyId/returns/:companyReturnId'
export const PATH_COMPANY_RETURN_QUESTIONS = `${PATH_COMPANY_RETURN}/questions`
export const PATH_COMPANY_RETURN_PAYMENT = `${PATH_COMPANY_RETURN}/payment`
export const PATH_COMPANY_RETURN_PAYMENT_CONFIRMED = `${PATH_COMPANY_RETURN}/paymentConfirmed`
export const PATH_COMPANY_RETURN_SUMMARY = `${PATH_COMPANY_RETURN}/summary`
export const PATH_COMPANY_RETURN_ADDITIONAL_INFO = `${PATH_COMPANY_RETURN}/additionalInfo`
export const PATH_COMPANY_RETURN_SUBMIT = `${PATH_COMPANY_RETURN}/submit`
export const PATH_COMPANY_RETURN_STATUS = `${PATH_COMPANY_RETURN}/status`

export const PATH_COMPANY_OFFICER_EMAIL_REFERRAL_AUTH = '/company/referral/auth'
export const PATH_COMPANY_OFFICER_EMAIL_REFERRAL_CONNECT = '/company/referral/connect'
